import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {useQuery} from "@tanstack/react-query";
import SlaCollectionService from "../../../../services/reports/sla-collection-service.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { data: smartcaptureOpt } = useQuery({
        queryFn: () =>  SlaCollectionService.smartcapture(),
        queryKey: ['smartcapture'],
        initialData: [],
    });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart ? new Date(filters.dtStart) : null}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <SelectComponent
                        label='SmartCapture *'
                        isMulti={true}
                        wrapValues={true}
                        options={ smartcaptureOpt }
                        value={filters.smartcapture}
                        onChange={(value) => setFilters(prev => ({...prev, smartcapture: value}))}
                        instanceId="smartcapture"
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />

                    <InputCheckbox
                        className={"w-full"}
                        id="searchDetails"
                        checked={filters.searchDetails}
                        label="Detalhamento da pesquisa"
                        onChange={(e) => setFilters(prev => ({...prev, searchDetails: e.target.checked}))} />
                </form>
            </div>
        </>
    );
};

export default Filters;